import { NgModule } from '@angular/core';
import { ZendeskModel } from './shared/features/zendesk/zendesk.model';
import { ZendeskModule } from './shared/features/zendesk/zendesk.module';

export class ZendeskConfig extends ZendeskModel {
  accountUrl = 'biodigital.zendesk.com';
  beforePageLoad(zE) {
    zE.setLocale('en');
    zE.hide();
  }
}

@NgModule({
  declarations: [],
  imports: [ZendeskModule.forRoot(ZendeskConfig)],
})
export class ZendeskConfigModule {}
